// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo__logo--overlay--2xKKA"};
    if(module.hot) {
      // 1571674783066
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  